import { CommonClientError } from "../../error/client-error";
import { DateUtils } from "../../primitive-utils";
import { DateTimeRange } from "../date-time";
import { LOCAL_DATE_FORMAT } from "../time-format";
import { LocalDateFunc } from "./local-date";
export class DateRange {
    v;
    constructor(v) {
        this.v = v;
    }
    static of({ startOn: startOnValues, endOn: endOnValues }) {
        const startOn = LocalDateFunc.of(startOnValues);
        const endOn = LocalDateFunc.of(endOnValues);
        return this.between({ startOn, endOn });
    }
    static between({ startOn, endOn }) {
        if (startOn.isAfter(endOn)) {
            throw new CommonClientError.InvalidInput(`startOn[${startOn.toString()}]はendOn[${endOn.toString()}よりも前の日付を指定してください。]`, `開始日付は終了日付よりも前の日付を指定して下さい。`);
        }
        return new DateRange({ startOn, endOn });
    }
    static union(...dateRanges) {
        return dateRanges.reduce((sum, d) => this.unionInternal(sum, d));
    }
    static unionInternal(a, b) {
        return DateRange.between({
            startOn: a.v.startOn.isBefore(b.v.startOn) ? a.v.startOn : b.v.startOn,
            endOn: a.v.endOn.isBefore(b.v.endOn) ? b.v.endOn : a.v.endOn,
        });
    }
    // 期間を保ったままスライドさせる
    shiftToNextRange() {
        const count = this.countDays();
        const nextStartDate = this.v.endOn.addDays(1);
        return DateRange.between({
            startOn: nextStartDate,
            endOn: nextStartDate.addDays(count),
        });
    }
    // startOn <= date <= endOn かどうか
    contains(date) {
        return (this.v.startOn.isEqualOrBefore(date) && date.isEqualOrBefore(this.v.endOn));
    }
    isOverlap(other) {
        const lastStart = this.v.startOn.isBefore(other.v.startOn)
            ? other.v.startOn
            : this.v.startOn;
        const earlyEnd = this.v.endOn.isBefore(other.v.endOn)
            ? this.v.endOn
            : other.v.endOn;
        if (earlyEnd.isBefore(lastStart)) {
            return false;
        }
        return true;
    }
    countDays() {
        return DateUtils.differenceInDays(this.v.endOn.toDate(), this.v.startOn.toDate());
    }
    countDaysIncludeStartDate() {
        return DateUtils.differenceInDays(this.v.endOn.toDate(), this.v.startOn.subDays(1).toDate());
    }
    toDateTimeRange() {
        return DateTimeRange.between({
            startAt: this.v.startOn.atStartOfDay(),
            endAt: this.v.endOn.addDays(1).atStartOfDay(),
        });
    }
    toArray() {
        const array = [];
        for (let date = this.v.startOn; date.isEqualOrBefore(this.v.endOn); date = date.addDays(1)) {
            array.push(date);
        }
        return array;
    }
    toValues() {
        return {
            startOn: this.v.startOn.toValues(),
            endOn: this.v.endOn.toValues(),
        };
    }
    toString() {
        return this.format(LOCAL_DATE_FORMAT);
    }
    format(dateFormat, connectingSign = "~") {
        const startString = this.v.startOn.format(dateFormat);
        const endString = this.v.endOn.format(dateFormat);
        if (startString === endString) {
            return startString;
        }
        return `${startString}${connectingSign}${endString}`;
    }
}
//# sourceMappingURL=date-range.js.map